<div class="container flex flex-col gap-2">
  <div class="flex justify-between">
    <div class="flex">
      <a class="logo flex items-center">
        <img src="assets/halliburton.svg" alt="halliburton-logo" width="120" height="40" />
      </a>
      <span class="name flex items-center">3D WORKFLOW</span>
    </div>
    <li class="username flex items-center justify-end">
      <p-menu #menu [model]="items()" [popup]="true" styleClass="menu-user" appendTo="body" />
      <p-avatar [label]="labelAvatar" class="mr-2" size="normal" shape="circle" styleClass="avatar-user" (click)="menu.toggle($event)" />
    </li>
  </div>
  <div class="flex justify-between flex-wrap gap-2">
    <div class="flex items-center">
      @if (currentStep() !== ROUTES.SELECT_CHALLENGES && !isVDR) {
        <div class="mr-1 lg:mr-4">
          <p-button class="restart-btn" (onClick)="restartWorkflow()">
            <div class="restart-btn_title">New WorkFlow</div>
            <i class="fa fa-refresh restart-btn_icon" aria-hidden="true"></i>
          </p-button>
        </div>
      }
      @if (currentStep() !== ROUTES.SELECT_CHALLENGES) {
        <p-tag [value]="diagnosisSessionStatus" styleClass="tag-status" [class]="STATUS_CLASS_MAPPING[diagnosisSessionStatus]" />
      }
    </div>
    <div class="flex">
      @if (currentStep() === ROUTES.VIEW_SUMMARY && !isVDR) {
        <div class="back">
          <p-button class="back-btn" (click)="backToPreviousScreen()">
            <div class="back-btn_title">Back</div>
            <i class="fa fa-arrow-left back-btn_icon" aria-hidden="true"></i>
          </p-button>
        </div>
      }

      @if (currentStep() !== ROUTES.VIEW_SUMMARY) {
        @if (isVDR) {
          <div class="initialize-grid-item ml-1 lg:ml-4">
            <p-button
              class="next-page-btn"
              [label]="buttonLabel.SolutionSelectionCompleted"
              (onClick)="solutionSelectionCompleted()"
              [disabled]="nextBtnDisabled()"
              [ngClass]="{
                'not-disable-btn': !nextBtnDisabled(),
              }"
            />
          </div>
        } @else {
          <div class="initialize-grid-item ml-1 lg:ml-4">
            <p-button
              class="next-page-btn"
              [label]="nextStepButtonLabel[currentStep()]"
              (onClick)="navigateToNextScreen()"
              [disabled]="nextBtnDisabled()"
              [ngClass]="{
                'not-disable-btn': !nextBtnDisabled(),
              }"
            />
          </div>
        }
      }
    </div>
  </div>
</div>
